module.exports = __webpack_public_path__ + "img/certificado2.47c2a3f0.png";